import { Offer } from '../offer/offer.types';
import { SortDirection } from '../sort/sort.enums';
import {
  BrockmeyerCampaignSortAttribute,
  BrockmeyerCampaignStatus,
  BrockmeyerChannelsSortAttribute,
} from './brockmeyer.enums';

export type BrockmeyerPrice = {
  amount: number;
  currency: {
    decimalDigits: number;
    decimalSeparator: string;
    iso: string;
    name: string;
    rounding: number;
    spaceBetweenAmountAndSymbol: boolean;
    symbol: string;
    symbolOnLeft: boolean;
    thousandsSeparator: string;
  };
};

export type BrockmeyerCampaignParams = {
  educations: BrockmeyerCampaignParam[];
  jobCompetences: BrockmeyerCampaignParam[];
  jobLevels: BrockmeyerCampaignParam;
  jobProfiles: BrockmeyerCampaignParam[];
  regions: BrockmeyerCampaignParamRegion[];
  sectors: BrockmeyerCampaignParam;
  channelTypes: BrockmeyerCampaignParamChannelType[];
};

export interface BrockmeyerCampaign {
  campaignChannels: BrockmeyerCampaignChannel[];
  companyJobsUrl: string;
  dateEnd: string;
  dateStart: string;
  dateStartPreferred: string;
  educations: BrockmeyerCampaignParam[];
  id: number;
  jobCompetence: BrockmeyerCampaignParam[];
  jobDescription: string;
  jobLevel: BrockmeyerCampaignParam;
  jobProfiles: BrockmeyerCampaignParam[];
  jobRequirements: string;
  jobSummary: string;
  jobTitle: string;
  jobUrl: string;
  offerId: number;
  offer: Offer;
  paymentEvent: {
    companyId: number;
    guid: string;
    price: BrockmeyerPrice;
    pspReference: string;
    status: string;
    refusalReason: string;
  };
  regions: BrockmeyerCampaignParamRegion[];
  sector: BrockmeyerCampaignParam;
  status: BrockmeyerCampaignStatus;
  targetPrice: BrockmeyerPrice;
  name: string;
}

export interface BrockmeyerCampaignWithPrice extends BrockmeyerCampaign {
  price: BrockmeyerPrice | undefined;
}

export type BrockmeyerCampaignChannel = {
  campaignId: number;
  channel: BrockmeyerChannel;
  channelId: string;
  channelName: string;
  id: number;
  listPrice: BrockmeyerPrice;
  postingUrl: string;
  stats: BrockmeyerCampaignChannelStats;
};

export type BrockmeyerCampaignChannelStats = {};

export type BrockmeyerCampaignParam = {
  id: number | string;
  name: string;
};

export type BrockmeyerCampaignParamChannelType = {
  id: string;
  name: string;
};

export type BrockmeyerCampaignParamRegion = {
  id: number;
  name: string;
  placeId: string;
};

export type BrockmeyerCampaignMeta = {
  activeCount: number;
  expiredCount: number;
  admins: any[];
};

export type BrockmeyerChannel = {
  id: string;
  channelType: string;
  daysOnline: number;
  educations: string[];
  listPrice: BrockmeyerPrice;
  logo: string;
  name: string;
  ranking: number;
  regions: string[];
  sectors: string[];
  summary: string | null;
  url: string | null;
  suggestionScore?: number;
};

export type BrockmeyerSearchParams = {
  adminIds: number[];
  limit: number;
  offerIds: number[];
  page: number;
  q: string;
  sortAttribute: BrockmeyerCampaignSortAttribute;
  sortOrder: string;
  statuses: BrockmeyerCampaignStatus[];
};

export type BrockmeyerChannelsSearchParams = {
  educations?: any[];
  exclude?: any[];
  limit?: number;
  page?: number;
  regions?: any[];
  sectors?: any[];
  sortAttribute?: BrockmeyerChannelsSortAttribute;
  textSearch?: string;
  channelTypes?: any[];
  sortOrder?: SortDirection;
};

// enum SortDirection {
//   Asc = 'asc',
//   Desc = 'desc',
// }
